<template>
  <div class="container_box">

     <div  class="appstyle">
        <div  class="window-first">鸟鸟配音</div>
        <div  class="app-first"> 本站所有功能全部免费使用 </div>
        <div  class="app-first" style="margin-top: 10px;"> 内测功能会定向邀请捐赠者使用 </div>
        <div  class="peiyine-privacy">
          <router-link to="/hecheng" class="app-title"><i class="el-icon-mic"></i> 去配音</router-link>
          <router-link to="/peiyin" class="app-title">查看主播</router-link>
        </div>
    </div>

    <div  class="contaniner">
      <div  class="hechengy">
        <div  class="app-right">
          <div  class="app-icon2s">
            <img src="../assets/images/ali-pay.png" alt="支付宝捐赠码" class="app-icon2">
          </div>
          <div  class="app-title8">支付宝捐赠码</div>
          <div  class="app-active0" @click="submit">
            <p class="app-title7">
              提交捐赠
            </p>
          </div>
        </div>

        <div  class="app-right">
          <div  class="app-icon2s">
            <img src="../assets/images/wei-pay.png" alt="微信捐赠码" class="app-icon2">
          </div>
          <div  class="app-title8">微信捐赠码</div>
          <div  class="app-active0" @click="submit">
            <p  class="app-title7">
              提交捐赠
            </p>
          </div>
        </div>

      
      </div>


    </div>


    <div class="infinite-list-wrapper juan" style="overflow:auto">
      <div class="title">近期捐赠</div>

      <el-table
      :data="count"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="用户名"
        width="180">
      </el-table-column>
      <el-table-column
        prop="price"
        label="捐赠金额"
        width="180">
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="时间">
      </el-table-column>
    </el-table>


      <p v-if="loading">加载中...</p>
      <p v-if="noMore">没有更多了</p>
    </div>


    <el-dialog title="捐赠信息" :visible.sync="submit_juan">
      <el-upload
        ref="uploadimg"
        list-type="picture-card"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove"
        :on-exceed="limit"
        :on-success="uped"
        
        action="/api/tts/upload"
        :before-upload="check" :limit="1" :headers=header 
        >
        <i class="el-icon-plus"></i>
        <div class="el-upload__tip" slot="tip">请上传转账截图，且不超过10M</div>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submit_juan = false">取 消</el-button>
        <el-button type="primary" @click="submit_juankuan">提交 </el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<style>
.juan{
  width:40%;
  margin:0 auto;
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: 0.2s;
  margin-top: 30px;
  padding:10px;

}
.juan p {
  text-align:center;
  color:#909399;
  font-size:13px;
}
.juan .title{
  text-align:center;
  display:block;
  padding-bottom:10px;
  color:#303133;
  font-weight: 600;
}
.juan span{
  margin-left:20px;
}

</style>
<script>
export default {
  data(){
    return{
      activeIndex:"5",
      count: [],
      loading: false,
      submit_juan:false,
      header:{"token":this.$store.getters.getToken},
      dialogImageUrl: '',
        dialogVisible: false,
        uploadfile:""
    }
  },
  mounted() {
      this.$store.commit("setActiveIndex",this.activeIndex);
      this.load();
  },
  computed: {
    noMore () {
      return this.count.length == 0
    },
    disabled () {
      return this.loading || this.noMore
    }
  },
  methods: {
    load () {
      this.loading = true
      this.axios({
        method: "post",
        url: "/api/tts/juan",
        data: {
        },
      }).then((res) => {
        this.count = res.data.data
        this.loading=false
      })
    },
    submit(){
      this.submit_juan = true
    },
    check(file){
        const isJPG = file.type === 'image/jpeg';
        const isPng = file.type === 'image/png';
        const isGif = file.type === 'image/gif';
        const isJPEG = file.type === 'image/jpg';
       


        const isLt10M = file.size / 1024 / 1024 < 10;

        if (isJPG || isPng || isGif || isJPEG){

        } else {
          this.$message.error('上传头像图片只能是 JPG/PNG/GIF 格式!');
          return false
        }
        if (!isLt10M) {
          this.$message.error('上传图片大小不能超过 10MB!');
          return false
        }
        return true
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      console.log(file)
      this.dialogImageUrl = file.url;
      
      this.dialogVisible = true;
    },
    limit(files, fileList){
      this.$message.error('每次只能上传一张图片');
      
    },
    submit_juankuan(){
      let that = this
      this.axios({
        method: "post",
        url: "/api/tts/submit_juan",
        data: {
          img:that.uploadfile
        },
      }).then((res) => {
        if(res.data.code==200){
          that.$message.success('提交功能，感谢您的支持！');
          that.submit_juan=false;
          this.$refs.uploadimg.clearFiles()
        }else{
          that.$message.error(res.data.msg);
        }
      })

    },
    uped(response, file, fileList){
      this.uploadfile = response.data
      console.log(response)
    }
  }
  
}


</script>
